if (!customElements.get("shipping-bar")) {
  customElements.define(
    "shipping-bar",
    class ShippingBar extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.amount_els = this.querySelectorAll(".value");
        this.cartDraw =
          this.closest("cart-drawer") || this.closest(".ca__free-shipping");

        if (!this.cartDraw) return; //attached to cartDraw as rest gets rebuilt

        this.setSize();
      }

      setSize() {
        var limit = parseInt(this.dataset.limit);
        var total = this.dataset.potentialItems
          ? parseInt(this.dataset.cartTotal) +
            parseInt(this.dataset.potentialItems)
          : parseInt(this.dataset.cartTotal);

        var distance = (total / limit) * 100;

        Array.from(this.amount_els).forEach((amount_el) => {
          amount_el.innerHTML = Shopify.formatMoney(limit - total);
        });

        //set size property on cart draw as the rest gets replaced
        setTimeout(() => {
          //timeout to ensure element has be rendered
          this.cartDraw.style.setProperty(
            "--shipping-distance",
            `${distance > 100 ? 100 : distance}%`,
          );
          this.cartDraw.dataset.distance = distance > 100 ? 100 : distance;
        }, 0);
      }
    },
  );
}

